import React from 'react'

import { Autocomplete, TextField } from '@mui/material'
import useIsMobile from '../../hooks/useIsMobile'

const AutocompleteFilter = ({
  multiple,
  options,
  value,
  setQueryString,
  getOptionLabel,
  onChange,
  placeholder,
  index,
  isOptionEqualToValue,
}) => {
  const isMobile = useIsMobile()
  return (
    <Autocomplete
      fullWidth
      sx={{ width: isMobile ? '100%' : '30%', maxWidth: '400px', ml: 1, mb: 1 }}
      multiple={multiple}
      options={options}
      value={value}
      renderInput={(params) => (
        <TextField
          onChange={(...args) => {
            if (params.onChange) params.onChange(...args)
            if (setQueryString) setQueryString(args[0].target.value)
          }}
          {...params}
          placeholder={placeholder}
        />
      )}
      getOptionLabel={getOptionLabel}
      onChange={onChange}
      isOptionEqualToValue={isOptionEqualToValue}
    />
  )
}
export default AutocompleteFilter
